var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFastFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6199_445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0826 30.653H26.2959C27.4159 30.653 28.3359 29.7997 28.4693 28.7063L30.6693 6.73301H24.0026V1.33301H21.3759V6.73301H14.7493L15.1493 9.85301C17.4293 10.4797 19.5626 11.613 20.8426 12.8663C22.7626 14.7597 24.0826 16.7197 24.0826 19.9197V30.653V30.653ZM1.33594 29.3197V27.9997H21.3759V29.3197C21.3759 30.053 20.7759 30.653 20.0293 30.653H2.6826C1.93594 30.653 1.33594 30.053 1.33594 29.3197V29.3197ZM21.3759 19.9863C21.3759 9.31967 1.33594 9.31967 1.33594 19.9863H21.3759ZM1.3626 22.6663H21.3626V25.333H1.3626V22.6663Z",
    fill: "#575757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6199_445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFastFood);
export default __webpack_public_path__ + "static/media/ico-fast-food.839e360e87c375b3449f91a3d9b2bc4d.svg";
export { ForwardRef as ReactComponent };